module.exports = __webpack_public_path__ + "static/media/HP_Thumbnail.c311ed7c.png";